export const ABOUT_CONTENT = {
  name: "Hassan Alawie",
  title: "Data Infrastructure Engineer · Curious Generalist",
  quote:
    "We are intelligent not because we can do one thing particularly well, but because we can learn to do practically anything.",
  quoteSource: "Jeff Hawkins, A Thousand Brains",
  location: "San Francisco, California",
  currentFocus: "Neuroscience × AI",
  bio: "Hey, friend! I’m a Systems Design Engineering graduate from the University of Waterloo, now building data infrastructure at a climate-tech startup. I’m happiest exploring the overlap between useful software, neuroscience, and AI.",
  tags: ["Neuroscience", "Data Infra", "AI", "Design Systems"],
  actions: [
    {
      label: "GitHub",
      href: "https://github.com/hassanalawie",
    },
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/in/hassanalawie/",
    },
  ],
};
